export default () => {
  if (import.meta.client) {
    // 禁止右键
    // document.addEventListener('contextmenu', (event) => {
    //   event.preventDefault()
    // })
    // // 禁止复制
    // document.addEventListener('copy', (event) => {
    //   event.preventDefault()
    // })
    // // 禁止剪切
    // document.addEventListener('cut', (event) => {
    //   event.preventDefault()
    // })
  }
}
